const mediaBreakPoint = '(max-width: 767px)';
const mq = window.matchMedia(mediaBreakPoint);

class Accordion {
    constructor (accordion, animationPanel) {
        this.accordion = accordion;
        this.animationPanel = animationPanel || false;
        this.allExpanded = false;
        
        this.allowMultiple = this.accordion.hasAttribute('data-allow-multiple');
        this.allowToggle = this.allowMultiple ? this.allowMultiple : this.accordion.hasAttribute('data-allow-toggle');

        this.triggers = this.accordion.querySelectorAll('.accordion-trigger:not(.always-open)');
        this.panels = this.accordion.querySelectorAll('.accordion-panel');

        if (!this.allowToggle) {
            const expanded = this.accordion.querySelector('[aria-expanded="true"]');

            if (expanded) {
                expanded.setAttribute('aria-disabled', 'true');
            }
        }
    }

    init () {
        for (const trigger of this.triggers) {
            trigger.addEventListener('click', this.handleClick.bind(this));
            trigger.addEventListener('keydown', this.handleKeydown.bind(this));
            trigger.addEventListener('focus', this.handleControllerFocus.bind(this));
            trigger.addEventListener('blur', this.handleControllerBlur.bind(this));
        }

        window.addEventListener('resize', this.handleWindowResize.bind(this));
    }

    handleClick (event) {
        const target = event.currentTarget;

        if (target.classList.contains('accordion-trigger')) {
            event.preventDefault();
            event.stopPropagation();

            const isExpanded = target.getAttribute('aria-expanded') === 'true';
            const active = this.accordion.querySelector('[aria-expanded="true"]');

            if (!this.allowMultiple && active && active !== target) {
                active.setAttribute('aria-expanded', 'false');
                const activedPanel = this.accordion.querySelector('#' + active.getAttribute('aria-controls'));
                if (this.animationPanel) {
                    activedPanel.style.height = 0;
                    activedPanel.classList.add('hidden');
                }
                activedPanel.setAttribute('hidden', '');
    
                if (!this.allowToggle) {
                    active.removeAttribute('aria-disabled');
                }
            }
            
            if (!isExpanded) {
                target.setAttribute('aria-expanded', 'true');

                const targetAcctionPanel = this.accordion.querySelector('#' + target.getAttribute('aria-controls'));
                if (this.animationPanel) {
                    targetAcctionPanel.style.height = targetAcctionPanel.scrollHeight + 'px';
                    targetAcctionPanel.classList.remove('hidden');
                }
                targetAcctionPanel.removeAttribute('hidden');
    
                if (!this.allowToggle) {
                    target.setAttribute('aria-disabled', 'true');
                }
            } else if (this.allowToggle && isExpanded) {
                target.setAttribute('aria-expanded', 'false');
                const targetdPanel = this.accordion.querySelector('#' + target.getAttribute('aria-controls'));
                if (this.animationPanel) {
                    targetdPanel.style.height = 0 + 'px';
                    targetdPanel.classList.add('hidden');
                }
                targetdPanel.setAttribute('hidden', '');
            }
        }
    }

    handleKeydown (event) {
        const target = event.currentTarget;
        const key = event.which.toString();
        // 33 = Page Up, 34 = Page Down
        const ctrlModifier = (event.ctrlKey && key.match(/33|34/));

        if (target.classList.contains('accordion-trigger')) {
            // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
            // 38 = Up, 40 = Down
            if (key.match(/38|40/) || ctrlModifier) {
                let index = this.triggers.indexOf(target);
                let direction = (key.match(/34|40/)) ? 1 : -1;
                let length = this.triggers.length;
                let newIndex = (index + length + direction) % length;

                this.triggers[newIndex].focus();

                event.preventDefault();
            } else if (key.match(/35|36/)) {
                // 35 = End, 36 = Home keyboard operations
                switch (key) {
                    // Go to first accordion
                    case '36':
                        this.triggers[0].focus();
                        break;
                    
                    // Go to last accordion
                    case '35':
                        this.triggers[this.triggers.length - 1].focus();
                        break;
                }
                event.preventDefault();
            }
        }
    }

    expandedAll() {
        for (const trigger of this.triggers) {
            trigger.setAttribute('aria-expanded', 'true');
            trigger.setAttribute('aria-disabled', 'true');
            trigger.disabled = true;
            const triggerAccorditionPanel = this.accordion.querySelector('#' + trigger.getAttribute('aria-controls'));
            if (this.animationPanel) {
                triggerAccorditionPanel.style.height = triggerAccorditionPanel.offsetHeight;
                triggerAccorditionPanel.classList.remove('hidden');
            }
            triggerAccorditionPanel.removeAttribute('hidden');
        }
        this.allExpanded = true;
    }

    handleControllerFocus (event) {
        this.accordion.classList.add('focus');
    }
    
    handleControllerBlur (event) {
        this.accordion.classList.remove('focus');
    }

    closeExpandedPanel () {
        for (const trigger of this.triggers) {
            if (trigger.getAttribute('aria-expanded') === 'true' && !trigger.classList.contains('always-open')) {
                trigger.setAttribute('aria-expanded', 'false');
                trigger.setAttribute('aria-disabled', 'false');
                trigger.disabled = false;
                const triggerAccorditionPanel = this.accordion.querySelector('#' + trigger.getAttribute('aria-controls'));
                if (this.animationPanel) {
                    triggerAccorditionPanel.style.height = 0 + 'px';
                    triggerAccorditionPanel.classList.add('hidden');
                }
                triggerAccorditionPanel.setAttribute('hidden', '');
            }    
        }
        this.allExpanded = false;     
    }

    handleWindowResize(event) {
        if (this.accordion.classList.contains('contact-accordion')) {
            if (!this.allExpanded && !mq.matches) {
                this.expandedAll();  
            } else if (this.allExpanded && mq.matches) {
                this.closeExpandedPanel();
            }
        }
    }
}

const tcAccordions = document.querySelectorAll('.tc-accordion');
for(const accordionElem of tcAccordions) {
    const accordion = new Accordion(accordionElem);
    accordion.init();
}

const contactAccordions = document.querySelectorAll('.contact-accordion');
for(const accordionElem of contactAccordions) {
    const accordion = new Accordion(accordionElem);
    accordion.init();
    if (!mq.matches) {
        accordion.expandedAll();  
    } 
}
